export const EXERCISES_ROUTES: { [exerciseName: string]: { NAME: string; PATH: string } } = {
  CHAT: {
    NAME: "exercise-chat",
    PATH: "/exercise/:courseUuid/chat/:exerciseUuid/:assignmentId?"
  },
  DEMO: {
    NAME: "exercise-demo",
    PATH: "/exercise/:courseUuid/demo/:exerciseUuid/:assignmentId?"
  },
  DICTATION: {
    NAME: "exercise-dictation",
    PATH: "/exercise/:courseUuid/dictation/:exerciseUuid/:assignmentId?"
  },
  DRILL_LISTENING: {
    NAME: "exercise-drill-listening",
    PATH: "/exercise/:courseUuid/drill-listening/:exerciseUuid/:assignmentId?"
  },
  DRILL_PRONUNCIATION: {
    NAME: "exercise-drill-pronunciation",
    PATH: "/exercise/:courseUuid/drill-pronunciation/:exerciseUuid/:assignmentId?"
  },
  DRILL_VOCABULARY: {
    NAME: "exercise-drill-vocabulary",
    PATH: "/exercise/:courseUuid/drill-vocabulary/:exerciseUuid/:assignmentId?"
  },
  EXERCISE_ROOT: {
    NAME: "exercise-root",
    PATH: "/exercise/:courseUuid/:exerciseUuid/:assignmentId?"
  },
  PICTURE_MATCH: {
    NAME: "exercise-picture-match",
    PATH: "/exercise/:courseUuid/picture-match/:exerciseUuid/:assignmentId?"
  },
  QUIZ_LISTENING: {
    NAME: "exercise-quiz-listening",
    PATH: "/exercise/:courseUuid/quiz-listening/:exerciseUuid/:assignmentId?"
  },
  DRILL_TYPING: {
    NAME: "exercise-drill-typing",
    PATH: "/exercise/:courseUuid/drill-typing/:exerciseUuid/:assignmentId?"
  },
  SINGLE_SENTENCE_READING: {
    NAME: "single-sentence-reading",
    PATH: "/exercise/:courseUuid/single-sentence-reading/:exerciseUuid/:assignmentId?"
  },
  QUIZ_TRANSLATION: {
    NAME: "exercise-quiz-translation",
    PATH: "/exercise/:courseUuid/quiz-translation/:exerciseUuid/:assignmentId?"
  },
  DRILL_TRANSLATION: {
    NAME: "exercise-drill-translation",
    PATH: "/exercise/:courseUuid/drill-translation/:exerciseUuid/:assignmentId?"
  }
};
